import type { PropertiesNullable } from '@@types/helpers'
import type {
  ApplicationConfiguration,
  AvailableLanguage,
  Maybe
} from '@server/graphql/typeDefs/types'

export default class EntityApplicationConfiguration
  implements PropertiesNullable<ApplicationConfiguration>
{
  availableLanguages: Maybe<AvailableLanguage[]> = null

  constructor(data: Partial<ApplicationConfiguration>) {
    Object.assign(this, data)
  }
}
